<nav class="bg-c-yellow" id="nav-customer-name">
  <span style="color: black;" i18n="@@CustomerName">E-Mail:&ensp;</span><strong>{{ masterUserByCustomer?.email }}</strong>
</nav>

<main id="customer-overview">
  <div class="card">
    <nav>
      <div id="nav-tab" role="tablist">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab" orientation="horizontal" class="nav-tabs nav-pills d-none d-lg-flex">
          <li [ngbNavItem]="'dashboard'" domId="tab_dashboard" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="dashboard" i18n="@@DashboardLink">Dashboard</a>
          </li>

          <li [ngbNavItem]="'energy-monitor'" domId="tab_energy-monitor" *ngIf="this.hasBlackbox">
            <a ngbNavLink routerLink="energy-monitor" i18n="@@CustomerEnergyLink">Energiemonitor</a>
          </li>

          <li [ngbNavItem]="'bidi-charging'" domId="tab_bidi-charging" *ngIf="this.hasBidi">
            <a ngbNavLink routerLink="bidi-charging" i18n="@@CustomerBidiLink">Bidi-Laden</a>
          </li>

          <li [ngbNavItem]="'users'" domId="tab_users" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="users" i18n="@@UserLink">Benutzer</a>
          </li>

          <li [ngbNavItem]="'rfid'" domId="tab_rfid" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="rfid" i18n="@@AuthorisationLink">RFID-Karten</a>
          </li>

          <li [ngbNavItem]="'unassigned-rfid'" domId="tab_unassignedRfid" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="unassigned-rfid" i18n="@@UnassignedRfidCardsLink">Nicht zugeteilte RFID-Karten</a>
          </li>

          <li [ngbNavItem]="'pricings'" domId="tab_pricings" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="pricings" i18n="@@PricingsLink">Tarife</a>
          </li>

          <li [ngbNavItem]="'invoices'" domId="tab_invoices" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="invoices" i18n="@@InvoicesLink">Rechnungen</a>
          </li>

          <li [ngbNavItem]="'chargingstations'" domId="tab_chargingstations">
            <a ngbNavLink routerLink="chargingstations" i18n="@@ChargingStationsLink">Ladestationen</a>
          </li>

          <li [ngbNavItem]="'charging-statistics'" domId="tab_chargingStatistics" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="charging-statistics" i18n="@@ChargingStatisticsLink">Ladestatistik</a>
          </li>

          <li [ngbNavItem]="'delivery-notes'" domId="tab_deliveryNotes" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="delivery-notes" i18n="@@DeliveryNotesLink">Lieferscheine</a>
          </li>

          <li [ngbNavItem]="'payment-receipts'" domId="tab_paymentReceipts" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="payment-receipts" i18n="@@PaymentReceiptsLink">Zahlungsbelege</a>
          </li>

          <li [ngbNavItem]="'chargingstations-status-log'" domId="tab_statuslog">
            <a ngbNavLink routerLink="chargingstations-status-log" i18n="@@ChargingStationsStatusLogLink">Status-Log</a>
          </li>

          <li [ngbNavItem]="'transactions'" domId="tab_transactions">
            <a ngbNavLink routerLink="transactions" i18n="@@ChargingTransactions">Ladevorgänge</a>
          </li>

          <li [ngbNavItem]="'groups'" domId="tab_groups" *ngIf="!this.isProduction && !isSupporter">
            <a ngbNavLink routerLink="groups" i18n="@@GroupsLink">Ladegruppen</a>
          </li>

          <li [ngbNavItem]="'profile'" domId="tab_profile" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="profile" i18n="@@ProfileLink">Konto</a>
          </li>

          <li [ngbNavItem]="'permissions'" domId="tab_permissions" *ngIf="!this.isProduction">
            <a ngbNavLink routerLink="permissions" i18n="@@CustomerPermissionsLink">Abo-Modell</a>
          </li>

          <!--<li [ngbNavItem]="'history'" domId="tab_history" *ngIf="!this.isProduction">
      <a ngbNavLink routerLink="history" i18n="@@CustomerHistoryLink">Notizen</a>
    </li>-->
        </ul>
        <nav class="navbar navbar-expand-xl d-lg-none text-dark border-bottom" ngbNav #nav="ngbNav" [activeId]="activeTab">
          <div class="container-fluid">
            <span class="navbar-brand" href="#">{{this.title}}</span>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"></path></svg>
            </button>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li [ngbNavItem]="'dashboard'" domId="tab_dashboard" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="dashboard" i18n="@@DashboardLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Dashboard</a>
                </li>

                <li [ngbNavItem]="'energy-monitor'" domId="tab_energy-monitor" *ngIf="this.hasBlackbox">
                  <a ngbNavLink routerLink="energy-monitor" i18n="@@CustomerEnergyLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Energiemonitor</a>
                </li>

                <li [ngbNavItem]="'bidi-charging'" domId="tab_bidi-charging" *ngIf="this.hasBidi">
                  <a ngbNavLink routerLink="bidi-charging" i18n="@@CustomerBidiLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Bidi-Laden</a>
                </li>

                <li [ngbNavItem]="'users'" domId="tab_users" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="users" i18n="@@UserLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Benutzer</a>
                </li>

                <li [ngbNavItem]="'rfid'" domId="tab_rfid" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="rfid" i18n="@@AuthorisationLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">RFID-Karten</a>
                </li>

                <li [ngbNavItem]="'unassigned-rfid'" domId="tab_unassignedRfid" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="unassigned-rfid" i18n="@@UnassignedRfidCardsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Nicht zugeteilte RFID-Karten</a>
                </li>

                <li [ngbNavItem]="'pricings'" domId="tab_pricings" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="pricings" i18n="@@PricingsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Tarife</a>
                </li>

                <li [ngbNavItem]="'invoices'" domId="tab_invoices" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="invoices" i18n="@@InvoicesLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Rechnungen</a>
                </li>

                <li [ngbNavItem]="'chargingstations'" domId="tab_chargingstations">
                  <a ngbNavLink routerLink="chargingstations" i18n="@@ChargingStationsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Ladestationen</a>
                </li>

                <li [ngbNavItem]="'charging-statistics'" domId="tab_chargingStatistics" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="charging-statistics" i18n="@@ChargingStatisticsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Ladestatistik</a>
                </li>

                <li [ngbNavItem]="'delivery-notes'" domId="tab_deliveryNotes" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="delivery-notes" i18n="@@DeliveryNotesLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Lieferscheine</a>
                </li>

                <li [ngbNavItem]="'payment-receipts'" domId="tab_paymentReceipts" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="payment-receipts" i18n="@@PaymentReceiptsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Zahlungsbelege</a>
                </li>

                <li [ngbNavItem]="'chargingstations-status-log'" domId="tab_statuslog">
                  <a ngbNavLink routerLink="chargingstations-status-log" i18n="@@ChargingStationsStatusLogLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Status-Log</a>
                </li>

                <li [ngbNavItem]="'transactions'" domId="tab_transactions">
                  <a ngbNavLink routerLink="transactions" i18n="@@ChargingTransactions" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Ladevorgänge</a>
                </li>

                <li [ngbNavItem]="'groups'" domId="tab_groups" *ngIf="!this.isProduction && !isSupporter">
                  <a ngbNavLink routerLink="groups" i18n="@@GroupsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Ladegruppen</a>
                </li>

                <li [ngbNavItem]="'profile'" domId="tab_profile" *ngIf="!this.isProduction">
                  <a ngbNavLink routerLink="profile" i18n="@@ProfileLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Konto</a>
                </li>

                <li [ngbNavItem]="'permissions'" domId="tab_permissions" *ngIf="false && !this.isProduction">
                  <a ngbNavLink routerLink="permissions" i18n="@@CustomerPermissionsLink" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Abo-Modell</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </nav>

    <div class="card">
      <div class="card-body">
        <div class="tab-content mt-2" id="nav-tabContent">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
      <div class="d-flex">
        <div class="flex-fill d-none d-md-inline">
          <div class="d-flex">
            <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
            <div class="flex">
              <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize" class="form-control form-select custom-select" aria-label="" (change)="tableFunctions.onPageSizeChange('Operator' + activeTab)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="250">250</option>
              </select>
            </div>
          </div>
        </div>
        <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
          <ngb-pagination #pagination
                          [collectionSize]="(tableFunctions.total$ | async)!"
                          [(page)]="tableFunctions.page"
                          [pageSize]="tableFunctions.pageSize"
                          [maxSize]="tableFunctions.page == 4 ? 4 : 3"
                          [boundaryLinks]="true"
                          [rotate]="true">
          </ngb-pagination>
        </div>
        <div class="flex-fill justify-content-end d-none d-md-inline">
          <div class="d-flex float-end">
            <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
            <div class="flex">
              <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
                <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
